import { functions, } from '@/firebase'

export default {
    getDisputas({ commit }) {
        var tipos = functions.httpsCallable('httpStripeGetDisputas');
        return tipos()
            .then(r => {
                console.log(r);
                commit('setDisputas', r.data.disputas)
            })
    },
}